import { Directive, HostListener, forwardRef } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const TRIM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TrimValueAccessor),
    multi: true
};

@Directive({
    selector: 'input:not([type=checkbox]):not([type=radio]):not([type=datepicker])[formControlName],textarea[formControlName],input:not([type=checkbox]):not([type=radio]):not([type=datepicker])[formControl],textarea[formControl],input:not([type=checkbox]):not([type=radio]):not([type=datepicker])[ngModel],textarea[ngModel],[ngDefaultControl]',
    providers: [ TRIM_VALUE_ACCESSOR ]
})
export class TrimValueAccessor extends DefaultValueAccessor {
    @HostListener('input', ['$event.target.value'])
    ngOnChange = (val: string) => {
        this.onChange(val.trim());
    };

    writeValue(value: any): void {
        if (typeof value === 'string')
            value = value.trim();

        super.writeValue(value);
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/trimValueAccessor.ts